import type { CityConfig } from "@/pages/city-template/types";

export const maryvilleTnConfig: CityConfig = {
  city: "Maryville",
  state: "Tennessee",
  stateAbbr: "TN",
  slug: "maryville-tn",
  route: "/cities/maryville-tn",
  title: "Emergency & Expedited Passport Services Maryville TN | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Maryville, TN — as fast as 24 hours. No Maryville passport agency. Fast Passport Center couriers to the Nashville Passport Agency at 805 Broadway, about 180 miles west. A+ BBB rated. Serving Maryville College students, McGhee Tyson Airport travelers, and all Blount County families heading abroad for study, business, or vacation.",
  h1: "Emergency & Expedited Passport Services in Maryville, TN",
  heroSubtitle: "Maryville sits at the gateway to the Great Smoky Mountains in Blount County, just south of Knoxville and McGhee Tyson Airport. Fast Passport Center's registered couriers deliver your documents to the Nashville Passport Agency at 805 Broadway so you get a new or renewed passport as fast as 24 hours — whether you're a Maryville College student preparing for study abroad, a Blount County professional heading to an international conference, or a Smoky Mountain area family planning an overseas adventure.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Maryville%20Tennessee%20downtown%20with%20historic%20Blount%20County%20Courthouse%20dome%20and%20the%20charming%20Broadway%20Avenue%20streetscape%20during%20warm%20autumn%20afternoon%20sunlight%2C%20small%20southern%20college%20town%20architecture%20with%20Smoky%20Mountains%20foothills%20visible%20in%20background%2C%20wide%20angle%20professional%20photography%20with%20clean%20composition%20and%20natural%20colors&width=1800&height=700&seq=maryville-tn-hero-001&orientation=landscape",
  heroImageAlt: "Maryville Tennessee downtown with Blount County Courthouse and Smoky Mountain foothills",
  geoPosition: "35.7565;-83.9705",
  geoPlacename: "Maryville, Tennessee",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "Nashville Passport Agency",
    address: "805 Broadway, Nashville, TN 37203",
    distance: "Approximately 180 miles from Maryville — about 2 hours 45 minutes via I-40",
  },
  nearbyCitiesZips: [
    { name: "Maryville", zips: "37801, 37803, 37804" },
    { name: "Alcoa", zips: "37701" },
    { name: "Friendsville", zips: "37737" },
    { name: "Louisville", zips: "37777" },
    { name: "Greenback", zips: "37742" },
    { name: "Walland", zips: "37886" },
    { name: "Townsend", zips: "37882" },
    { name: "Rockford", zips: "37853" },
    { name: "Lenoir City", zips: "37771" },
    { name: "Vonore", zips: "37885" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Nashville Passport Agency — about 180 miles from Maryville via I-40" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Smoky Mountain Gateway", desc: "Serving Maryville, Alcoa, Friendsville, Townsend, and all Blount County" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Maryville case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in Nashville TN", route: "/cities/nashville" },
    { name: "Expedited passport in Knoxville TN", route: "/cities/knoxville" },
    { name: "Urgent passport in Maryville TN", route: "/cities/maryville-tn" },
    { name: "Tennessee passport hub", route: "/states/tennessee" },
    { name: "Fast passport in Chattanooga TN", route: "/cities/chattanooga" },
    { name: "Expedited passport in Johnson City TN", route: "/cities/johnson-city" },
    { name: "Emergency passport in Murfreesboro TN", route: "/cities/murfreesboro" },
  ],
  fpcOfficeAddress: "805 Broadway, Nashville, TN 37203",
  fpcOfficeNote: "Fast Passport Center serves Maryville remotely via secure courier. Our registered couriers hand-deliver your documents to the Nashville Passport Agency at 805 Broadway — approximately 180 miles west. Maryville is just minutes from McGhee Tyson Airport (TYS), making overnight courier routing efficient. Our dedicated agents ensure Blount County travelers never need to make the 2-hour-45-minute drive to Nashville for passport processing.",
  fpcOfficeDistance: "Serving all of Blount County and the Smoky Mountain foothills",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Maryville, Alcoa, Townsend, Friendsville, and the Blount County corridor. From Maryville College students studying abroad to McGhee Tyson Airport professionals heading to international assignments, we help Smoky Mountain gateway travelers get their passports fast.",
  nearbyCitiesIntro: "We serve Maryville and nearby communities including Alcoa, Friendsville, Louisville, Townsend, Greenback, Walland, and the entire Blount County area.",
  howItWorksIntro: "Most Maryville travelers complete everything online and ship documents overnight. At approximately 180 miles from Nashville, Fast Passport Center provides fast courier turnaround for Blount County residents — eliminating the nearly 3-hour drive to the Nashville Passport Agency.",
  mistakesIntro: "Maryville travelers, including Maryville College students studying abroad and McGhee Tyson Airport corporate professionals heading to international conferences, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Maryville and Blount County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Maryville? Here are the most common ones we hear from Blount County and Maryville College travelers.",
  statePageRoute: "/states/tennessee",
  statePageName: "Tennessee",
  dmvWebsite: "https://www.tn.gov/safety/driver-services.html",
  dmvLabel: "Tennessee Department of Safety — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins at 805 Broadway",
        "Life-or-death emergencies only",
        "180 miles to Nashville (2 hours 45 minutes via I-40/I-75)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for Maryville College students going abroad",
        "Perfect for McGhee Tyson Airport professional travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from TYS",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Maryville is 180 miles from the Nashville Passport Agency — our courier service saves Blount County travelers the 3-hour I-40 drive.",
      bullets: ["Blount County coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in Blount County",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Maryville adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Maryville and Blount County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Maryville and Blount County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Maryville and Blount County residents with DS-64 form guidance and courier routing to Nashville.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Nashville agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Blount County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Maryville and Blount County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Maryville TN", description: "Urgent passport processing for Maryville, TN travelers via Nashville Passport Agency courier — 180 miles from Maryville." },
    { name: "Passport Renewal Maryville TN", description: "Fast passport renewal for Maryville and Blount County, Tennessee residents." },
    { name: "New Passport Maryville TN", description: "First-time passport application assistance for Maryville and Blount County area residents." },
    { name: "Lost Passport Maryville TN", description: "Passport replacement for lost or stolen passports for Maryville and Blount County residents." },
    { name: "Child Passport Maryville TN", description: "Minor passport services for Maryville and Blount County families." },
    { name: "Name Change Passport Maryville TN", description: "Passport name change service for Maryville, TN residents." },
  ],
  testimonials: [
    {
      name: "Sarah K.",
      location: "Maryville College Student",
      rating: 5,
      text: "I'm a junior at Maryville College and got accepted to a semester exchange program in Spain. Realized 3 weeks before departure my passport had expired. Fast Passport Center renewed it in 4 business days. My dedicated agent walked me through every step — truly saved my study abroad semester.",
      service: "Emergency Renewal",
    },
    {
      name: "James T.",
      location: "Alcoa, TN",
      rating: 5,
      text: "McGhee Tyson Airport operations manager who was offered a last-minute international training program in Frankfurt. My passport was buried in a drawer and had expired. Fast Passport Center had me a new one in 3 business days. The overnight courier service was flawless.",
      service: "Passport Renewal",
    },
    {
      name: "The W Family",
      location: "Maryville, TN",
      rating: 5,
      text: "Blount County family of four planning a summer trip to Italy. We needed two adult renewals and two first-time child passports with only 5 weeks before departure. Fast Passport Center handled all four applications simultaneously — all passports arrived in 8 business days.",
      service: "Family Applications",
    },
    {
      name: "Linda R.",
      location: "Townsend, TN",
      rating: 5,
      text: "Retired teacher living in Townsend who realized my passport was missing 10 days before a long-planned British Isles tour. Fast Passport Center helped with the DS-64 lost passport form and couriered my replacement through Nashville. Passport in hand in 5 business days — made the tour.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "mv-1",
      name: "Maryville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "329 S Court St",
      city: "Maryville",
      state: "TN",
      zip: "37801",
      phone: "(865) 982-4721",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Maryville — Downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Maryville and Blount County residents. Appointment required. Located on Court Street near downtown Maryville.",
      icon: "ri-mail-line",
    },
    {
      id: "mv-2",
      name: "Blount County Clerk Office",
      type: "County Clerk Passport Acceptance",
      address: "345 Court St",
      city: "Maryville",
      state: "TN",
      zip: "37801",
      phone: "(865) 273-5800",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Maryville — Downtown",
      website: "https://www.blounttn.org",
      websiteLabel: "Blount County Government",
      notes: "County clerk passport acceptance services in the Blount County Courthouse. Convenient downtown location near Maryville College campus.",
      icon: "ri-government-line",
    },
    {
      id: "mv-3",
      name: "Alcoa Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1055 Hunters Crossing Dr",
      city: "Alcoa",
      state: "TN",
      zip: "37701",
      phone: "(865) 984-2431",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Alcoa — 5 miles north of Maryville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient option near McGhee Tyson Airport. Services Alcoa and north Blount County residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "mv-4",
      name: "Lenoir City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "302 E Broadway St",
      city: "Lenoir City",
      state: "TN",
      zip: "37771",
      phone: "(865) 986-2491",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lenoir City — 15 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for western Blount County and Loudon County residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "mv-5",
      name: "Knoxville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "501 W Main St",
      city: "Knoxville",
      state: "TN",
      zip: "37902",
      phone: "(865) 558-4591",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Knoxville — 20 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Full-service USPS passport acceptance in downtown Knoxville. Larger facility with more appointment availability than Maryville locations.",
      icon: "ri-mail-line",
    },
    {
      id: "mv-6",
      name: "Friendsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "207 N Farnum St",
      city: "Friendsville",
      state: "TN",
      zip: "37737",
      phone: "(865) 995-2391",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Friendsville — 10 miles northwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Small-town option for western Blount County residents. Call ahead — limited hours may vary.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Nashville Agency", agency: "180 miles — 2 hour 45 minute drive via I-40/I-75, but need appointment", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-map-pin-line",
      title: "Assuming the Knoxville Area Has a Passport Agency",
      description: "Maryville residents are just 20 minutes from Knoxville and often assume a passport agency exists there. The closest passport agency is in Nashville — 180 miles west. No passport agency exists in Knoxville, leaving Maryville travelers with no local emergency processing option except registered courier services.",
    },
    {
      icon: "ri-calendar-line",
      title: "Maryville College Students Waiting Until Finals Week",
      description: "Maryville College students accepted to study abroad programs often wait until finals week to handle passport applications — right when the Maryville Post Office and Blount County Clerk are busiest. Summer study abroad planning should start passport applications in March, not late April or May.",
    },
    {
      icon: "ri-global-line",
      title: "Confusing Student Visa Requirements With Passport Requirements",
      description: "Maryville College students heading to semester-long programs in the UK, Spain, or Japan often confuse passport validity with visa requirements. A valid passport is not the same as a valid student visa. Some countries require passports valid 6 months beyond the visa end date.",
    },
    {
      icon: "ri-restart-line",
      title: "Not Checking Passport Validity Before Booking From TYS",
      description: "Blount County travelers often book international flights from McGhee Tyson Airport months in advance without checking passport expiration dates. Most countries require 6 months passport validity beyond your return date. If your passport expires within 6 months of travel, airlines may deny boarding.",
    },
    {
      icon: "ri-image-line",
      title: "Using Maryville College Campus Photos as Passport Photos",
      description: "Maryville College students sometimes try to use student ID photos or self-taken phone photos for passport applications. Passport photos must be exactly 2x2 inches with a pure white background, neutral expression, and no glasses — only professional passport photo services meet U.S. Department of State standards.",
    },
    {
      icon: "ri-file-list-line",
      title: "Renewing by Mail When In-Person Is Required",
      description: "Maryville residents with passports that expired more than 5 years ago, were issued under age 16, or have a name change without documentation must use Form DS-11 (in-person application) — not DS-82 (mail-in). Filing the wrong form means your application gets rejected and you start over.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Maryville, Alcoa, or Knoxville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Nashville Passport Agency — 180 miles west via I-40." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Nashville Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Maryville or Blount County address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Maryville from the Nashville passport agency?",
      a: "Maryville is approximately 180 miles from the Nashville Passport Agency at 805 Broadway — about a 2 hour 45 minute drive west via I-140 to I-40. However, the Nashville agency requires pre-scheduled NPIC appointments and does not accept walk-ins. Appointments often fill 2–3 weeks in advance.",
    },
    {
      q: "Does Maryville, TN have its own passport agency?",
      a: "No. Maryville does not have a passport agency. The closest passport agency is the Nashville Passport Agency at 805 Broadway, about 180 miles west. Maryville only has passport acceptance facilities — the Maryville Post Office at 329 S Court St and the Blount County Clerk's office — which can accept DS-11 applications but cannot process or expedite them.",
    },
    {
      q: "I'm a Maryville College student — how fast can I get a passport for study abroad?",
      a: "Maryville College students heading to study abroad programs in Europe, Asia, or South America are frequent clients. Emergency processing delivers passports in 24–48 hours. Standard expedited processing runs 2–9 business days. We recommend starting the process at least 2–3 months before your program start date to allow time for student visa processing.",
    },
    {
      q: "Where do Maryville travelers typically fly internationally?",
      a: "Maryville travelers typically fly from McGhee Tyson Airport (TYS, just 5 miles north in Alcoa) for domestic connections to major hubs. For international flights, most Maryville travelers connect through Atlanta (ATL), Charlotte (CLT), or Nashville (BNA). TYS offers direct flights to several domestic hubs with international connections.",
    },
    {
      q: "How fast can I get an emergency passport in Maryville?",
      a: "Emergency processing is typically 24–48 hours for Maryville residents. Given Maryville's proximity to McGhee Tyson Airport and major UPS/FedEx shipping routes, overnight courier routing to Nashville is highly efficient. Standard expedited processing runs 2–9 business days.",
    },
    {
      q: "Where can I get passport photos in Maryville?",
      a: "Walgreens at 1906 W Broadway Ave and CVS Pharmacy at 1821 W Broadway Ave in Maryville both offer passport photo services. The UPS Store at 1103 E Lamar Alexander Pkwy also provides passport photos. Always verify your photos meet exact 2x2 inch specifications with a white background.",
    },
    {
      q: "Can the Blount County Clerk's office process my passport?",
      a: "Yes. The Blount County Clerk's office at 345 Court St in downtown Maryville accepts passport applications as a passport acceptance facility. They can accept DS-11 applications and verify your documents. Call (865) 273-5800 before visiting to confirm current passport service hours.",
    },
    {
      q: "How do I renew my passport in Maryville?",
      a: "Adult renewals meeting all DS-82 eligibility criteria (16 or older, issued within 15 years, same name) can be done entirely by mail. Fast Passport Center's courier service achieves 2–9 business day turnaround — far faster than self-service USPS (8–11 weeks). If you're not eligible for mail-in renewal, visit the Maryville Post Office or Blount County Clerk for an in-person DS-11 application.",
    },
    {
      q: "Does the Maryville Post Office take walk-in passport appointments?",
      a: "The Maryville Post Office at 329 S Court St accepts passport applications by appointment Monday through Friday from 9:00 AM to 4:00 PM. Walk-ins are generally not accepted — call (865) 982-4721 to schedule. The post office is often busiest during lunch hours and late afternoons.",
    },
    {
      q: "Can Fast Passport Center help Alcoa and Townsend residents too?",
      a: "Absolutely. We serve all of Blount County including Maryville, Alcoa, Friendsville, Townsend, Louisville, Greenback, Walland, and Rockford. Residents of surrounding communities never need to drive to Maryville or Nashville for service — our courier handles everything.",
    },
    {
      q: "I work at McGhee Tyson Airport — can you help with an international assignment passport?",
      a: "TYS professionals heading to international assignments or training programs should start passport preparation 3–4 months before travel. Fast Passport Center processes passports in 2–9 business days, but allow extra time for any country-specific visa processing after you receive your passport.",
    },
    {
      q: "Is the Blount County Clerk faster than the Maryville Post Office for passport applications?",
      a: "Both the Maryville Post Office and the Blount County Clerk's office serve as passport acceptance facilities with similar processing capabilities. The County Clerk's office at 345 Court St often has shorter wait times and more flexible hours (8:00 AM–4:30 PM vs. the post office's 9:00 AM–4:00 PM). However, neither facility can expedite processing — that's where Fast Passport Center's courier service comes in.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Maryville", address: "1906 W Broadway Ave, Maryville, TN 37801", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Maryville", address: "1821 W Broadway Ave, Maryville, TN 37801", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Maryville", address: "1103 E Lamar Alexander Pkwy, Maryville, TN 37804", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM" },
    { name: "Walmart Photo — Maryville", address: "1031 Hunters Crossing Dr, Alcoa, TN 37701", hours: "Mon–Sun: 7AM–9PM" },
    { name: "Walgreens — Alcoa", address: "244 S Calderwood St, Alcoa, TN 37701", hours: "Mon–Sun: 7AM–10PM" },
    { name: "FedEx Office — Knoxville West", address: "7228 Kingston Pike, Knoxville, TN 37919", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "TN Driver Services — Maryville", address: "318 Home Ave, Maryville, TN 37801", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Full-service Driver Services Center in Maryville. REAL ID, driver's license, and state ID services for Blount County residents.", featured: true },
    { name: "TN Driver Services — Alcoa", address: "250 E Watt St, Alcoa, TN 37701", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Convenient option near McGhee Tyson Airport. Serves Alcoa and north Blount County.", featured: false },
    { name: "TN Driver Services — Knoxville (Strawberry Plains)", address: "7320 Region Ln, Knoxville, TN 37914", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Larger Driver Services Center in Knoxville. About 25 miles north of Maryville.", featured: false },
  ],
  airports: [
    {
      code: "TYS",
      name: "McGhee Tyson Airport",
      distance: "5 miles north of Maryville",
      address: "2055 Alcoa Hwy, Alcoa, TN 37701",
      note: "Maryville's closest airport — just minutes from downtown. Domestic routes via major carriers with connections to international hubs. The most convenient departure point for Blount County travelers.",
      flightUrl: "https://flyknoxville.com/",
      flightLabel: "TYS Airport",
      featured: true,
    },
    {
      code: "BNA",
      name: "Nashville International Airport",
      distance: "180 miles west of Maryville",
      address: "1 Terminal Dr, Nashville, TN 37214",
      note: "Tennessee's busiest airport with extensive domestic and growing international routes. About 2 hours 45 minutes via I-40. Co-located with Nashville Passport Agency at 805 Broadway.",
      flightUrl: "https://flynashville.com/",
      flightLabel: "BNA Airport",
      featured: false,
    },
    {
      code: "ATL",
      name: "Hartsfield-Jackson Atlanta International",
      distance: "200 miles south of Maryville",
      address: "6000 N Terminal Pkwy, Atlanta, GA 30320",
      note: "World's busiest airport with direct international flights worldwide. About 3 hours 30 minutes via I-75. Major international gateway for Smoky Mountain region travelers.",
      flightUrl: "https://www.atl.com/",
      flightLabel: "ATL Airport",
      featured: false,
    },
    {
      code: "CHA",
      name: "Chattanooga Metropolitan Airport",
      distance: "100 miles southwest of Maryville",
      address: "1001 Airport Rd, Chattanooga, TN 37421",
      note: "Regional airport with domestic routes. About 1 hour 45 minutes via I-75. Alternative for Blount County residents in the southern portion of the county.",
      flightUrl: "https://www.chattairport.com/",
      flightLabel: "CHA Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Tennessee Department of Health Vital Records. Online, mail, or in-person options for Blount County residents.", url: "https://www.tn.gov/health/health-program-areas/vital-records.html" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through TN Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.tn.gov/health/health-program-areas/vital-records.html" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Blount County Clerk. Certified copies available for name changes.", url: "https://www.blounttn.org/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Blount County Circuit Court. Required for name change passport corrections.", url: "https://www.blounttn.org/" },
  ],
};